<template>
  <v-app class="app" style="
    background: rgba(0,0,0,0);">

    <v-main>

      <Nav />
      <router-view></router-view>

      <Footer class="footer"/>

    </v-main>


  </v-app>
</template>

<script>

import Vue from 'vue'
import Vuex from 'vuex'
import Nav from './components/Nav'


Vue.use(Vuex)

export const store = new Vuex.Store()

export default {
  name: 'App',

  components: {
    Nav
  },

    methods: {
    // Log the user in
      login() {
        console.log('starting login')
        this.$router.push('/login');
      },
      // Log the user out
      logout() {
        console.log('write logout');
        sessionStorage.clear();
        this.$store.dispatch('logout');
        window.location.replace('/login');
      },

      profile() {
        console.log('clicked the profile button')
      },

      filter() {
        console.log('filtering');
      },
      goHome() {
        console.log('starting goHome')
        this.$router.push('/home');
      }
    },


    computed: {
  user(){
    return this.$store.state.user.data
  }
        },
 

   data() {
     return {

      drawer: false,
      loggedIn: false,
      loggedInEmail: '',

      links: [

        {icon: 'mdi-home', text: 'Home', route: '/Home'},
        {icon: 'mdi-book-open-blank-variant', text: 'Books', route: '/Books'},
        {icon: 'mdi-google-circles-communities', text: 'Circles', route: '/Circles'},
        {icon: 'mdi-account-group', text: 'QuickConnect', route: '/QuickConnect'}
      ],
      
      disabled: false,
      absolute: false,
      openOnHover: false,
      value: false,
      closeOnClick: true,
      closeOnContentClick: true,
      offsetX: false,
      offsetY: true
  } 
  }
}

 

</script>

<style >

body {

background: url("./assets/background.jpg");
background-repeat: repeat;

}

.imageDiv {
  background: black;
}

  .footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: red;
   color: white;
   text-align: center;
}


</style>